// Obra logo — matches @use.obra Instagram profile:
// two thin-line building silhouettes over the word OBRA in a light,
// wide-tracked geometric sans-serif.

export function LogoMark({ size = 32, className = "", inverse = false }) {
  const stroke = inverse ? "#FFFFFF" : "#0A0A0A";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Left building — stepped rooftop */}
      <path
        d="M 28 82 L 28 8 L 40 8 L 40 22 L 52 22 L 52 82"
        stroke={stroke}
        strokeWidth="3.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
      {/* Right building — slanted roof rising to the right */}
      <path
        d="M 60 82 L 60 40 L 82 24 L 82 82"
        stroke={stroke}
        strokeWidth="3.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
    </svg>
  );
}

// Custom-drawn "OBRA" wordmark — the A has no crossbar to match the reference.
export function LogoWordmark({ height = 22, className = "", inverse = false }) {
  const stroke = inverse ? "#FFFFFF" : "#0A0A0A";
  const w = height * 8.5; // 4 letters with generous tracking
  return (
    <svg
      height={height}
      width={w}
      viewBox="0 0 340 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* O — perfect circle */}
      <circle cx="20" cy="20" r="18" stroke={stroke} strokeWidth="2" />

      {/* B */}
      <path
        d="M 88 2 L 88 38 M 88 2 L 108 2 A 9 9 0 0 1 108 20 L 88 20 M 88 20 L 110 20 A 9 9 0 0 1 110 38 L 88 38"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
      />

      {/* R */}
      <path
        d="M 165 38 L 165 2 L 185 2 A 9 9 0 0 1 185 20 L 165 20 M 178 20 L 190 38"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
      />

      {/* A — no crossbar, just an inverted V */}
      <path
        d="M 240 38 L 260 2 L 280 38"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
      />
    </svg>
  );
}

export default function Logo({
  size = 40,
  showWordmark = true,
  className = "",
  inverse = false,
  stacked = false,
}) {
  if (stacked) {
    return (
      <div className={`flex flex-col items-center gap-1 ${className}`}>
        <LogoMark size={size} inverse={inverse} />
        {showWordmark && <LogoWordmark height={size * 0.36} inverse={inverse} />}
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark size={size} inverse={inverse} />
      {showWordmark && <LogoWordmark height={size * 0.44} inverse={inverse} />}
    </div>
  );
}
